import { render, staticRenderFns } from "./replaceModel.vue?vue&type=template&id=00a6b0e4&scoped=true&"
import script from "./replaceModel.vue?vue&type=script&lang=js&"
export * from "./replaceModel.vue?vue&type=script&lang=js&"
import style0 from "./replaceModel.vue?vue&type=style&index=0&id=00a6b0e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00a6b0e4",
  null
  
)

export default component.exports